module.exports = __webpack_public_path__ + "img/speech_10.b8fbaf14.jpeg";